export default {"src":"/_next/static/media/food.78d03985.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};